import { DateTime } from 'luxon';
import { LicenseTerm } from './LicenseTerm';
import { LicenseTypeEnum } from '../licences/LicenseType';

export type UpdateLicenseTerm = Omit<LicenseTerm, 'id'> & {
    licenseTermId: string;
};

export const defaultUpdateLicenseTerms: UpdateLicenseTerm = {
    licenseTermId: '',
    licenseType: LicenseTypeEnum.Commercial,
    notes: '',
    downloadUrl: '',
    startDate: DateTime.fromISO(''),
    endDate: DateTime.fromISO(''),
};
